import axiosClient from ".";
class CurrencyLimitsAPI {
  static getCurrencyLimits() {
    return axiosClient.get("/api/v1/currency/configurations");
  }
}
export default CurrencyLimitsAPI;
